import api from '@/config/api'

export default {
  getAllStagehandHealth() {
    return api.get('/v2/stagehand/containers/full')
  },
  restartStagehand(stationName) {
    return api.get(`/v2/stagehand/restart/${stationName}`)
  },

  // @deprecated Docker Swarm deploy flow — remove once ND-1777 is complete.
  // Triggers GitLab CI to build a new station image, polls until done,
  // then swaps the image on the running Docker Swarm service and restarts it.
  rebuildImage(stationName) {
    return api.post(`/v2/stagehand/pipeline/BUILD_CONTAINER/${stationName}`)
  },
  getSwarmServices() {
    return api.get('/v2/docker/swarm/services')
  },
  deployLatestImage(serviceId, data) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/image`, data)
  },
  stopContainer(serviceId) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/stop`)
  },
  startContainer(serviceId) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/start`)
  },
  updateImageInfo() {
    return api.post('/v2/stagehand/images')
  }
}
